import { gemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  getPosts(payload) {
    return gemmiciApiServiceClient.get(
      "organization/organization_posts",
      payload
    );
  }
};
